// redux/importReseller/Types.ts

import { iStateMessage } from '@/customTypes/GenericReduxTypes';

export const REDUCER_NAME = 'importReseller';

/**
 * Single reseller subscription item
 * (based on backend response)
 */
export interface IResellerSubscription {
  subscriptionId: string;
  planId: string;
  planName: string;
  price: string;
  durationUnit: string;
  durationValue: number;
  startDate: string;
  endDate: string;
  isActive: number;
}

/**
 * Redux state
 */
export interface IImportResellerState {
  isLoading: boolean;
  resellerList: IResellerSubscription[];
  error: iStateMessage | null;
}
